export default {
  cancel: 'Cancel',
  confirm: 'Confirm',
  save: 'Save',
  saveChanges: 'Save Changes',
  delete: 'Delete',
  remove: 'Remove',
  back: 'Back',
  continue: 'Continue',
  retry: 'Retry',
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  login: 'Login',
  signUp: 'Sign Up',
  logout: 'Logout',
  accountSettings: 'Account Settings',
  settings: 'Settings',
  laplace: 'Laplace',
  freeTier: 'Free Tier',
  subscribe: 'Subscribe',
  trialDaysLeft_one: '{{count}} day left',
  trialDaysLeft_other: '{{count}} days left',
  trialExpired: 'Trial expired',
  trialBannerTitle_one: 'Heads up, your trial ends in {{count}} day',
  trialBannerTitle_other: 'Heads up, your trial ends in {{count}} days',
  trialBannerExpiredTitle: 'Your free trial has ended',
  trialBannerDescription:
    'When your trial wraps up, your connections and team member access will be removed. Subscribe now to keep everything.',
  copyright: '© {{year}} Laplace',
  termsOfService: 'Terms of Service',
  blog: 'Blog',
  privacyPolicy: 'Privacy Policy',
  refundPolicy: 'Refund Policy',
  trustSecurity: 'Security',
  telegram: 'Telegram',
  x: 'X',
  openAccountMenu: 'Open account menu',
  openNavigation: 'Open navigation',
  cookieConsentTitle: 'We use cookies',
  cookieConsentDescriptionBeforeReject:
    'By clicking "Accept All Cookies", you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and improve the product experience. You can also ',
  cookieConsentRejectLink: 'reject non-essential cookies',
  cookieConsentDescriptionBeforePrivacy: '. View our ',
  cookieConsentPrivacyPolicy: 'Privacy Policy',
  cookieConsentDescriptionAfterPrivacy: ' for more information.',
  cookieConsentAccept: 'Accept All Cookies',
  cookieConsentClose: 'Close cookie notice',
}
